import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as DataProductActions from 'redux/actions/Applications/DataProducts'

import Table from 'components/common/Table'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Paper from 'components_new/atoms/Paper'
import Text from 'components_new/atoms/Text'

import CreateDataProduct from 'components/containers/Applications/DataProducts/modals/CreateDataProduct'

import * as Conf from './conf.js'
import { useAccounts } from 'redux/hooks/Accounts'

const Overview = ({
  AuthStore,
  AppsDataProductStore,
  history,
  tryCreateDataproduct
}) => {
  const [apis, setApis] = useState(Object.values(AppsDataProductStore.data))
  const [createApi, setCreateApi] = useState(false)
  const { accountBody } = useAccounts()

  const count = apis.length

  useEffect(() => {
    if (AppsDataProductStore.data) {
      setApis(Object.values(AppsDataProductStore.data))
    }
  }, [AppsDataProductStore.data])

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Paper sx={{ p: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            mb: 1
          }}
        >
          <Text color="text.secondary" variant="caption">
            <b>{count}</b> delningar
          </Text>

          <Button
            onClick={() => setCreateApi(true)}
            startIcon={<Icon name="AddCircleOutlineOutlined" />}
          >
            Skapa delning
          </Button>
        </Box>

        <Table
          size={'middle'}
          headers={Conf.TABLE_HEADERS(AuthStore?.account)}
          rows={Conf.getRows(apis, accountBody)}
          parsedFormat
          onClick={(id) => history.push(`/access-hub/${id}/connection`)}
        />
      </Paper>

      <CreateDataProduct
        visible={createApi}
        onClose={() => setCreateApi(false)}
        tryCreateDataproduct={(values) => {
          tryCreateDataproduct(values, (id) => {
            setCreateApi(false)

            history.push(`/access-hub/${id}/connection`)
          })
        }}
        type={'API'}
      />
    </Box>
  )
}

function mapStateToProps({ AuthStore, AppsDataProductStore }) {
  return { AuthStore, AppsDataProductStore }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...DataProductActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Overview))
